<template>
  <v-app class="bg">
    <div class="mt-5">
      <section class="content">
        <CmpEmptyData
            class="mt-10"
            :btnShow="false"
            :txtCaptionShow="false"
        >
        </CmpEmptyData>
      </section>
    </div>
  </v-app>
</template>

<script>
import LayoutDefault from "../../../../layouts/LayoutDefault";
import CmpEmptyData from "../../../Cmp/public/CmpEmptyData.vue";

export default {
  components: {
    CmpEmptyData,
  },
  props: {
    serial_number: {},
    home_id: {},
    click: {}
  },
  data() {
    return {
      homeid: this.home_id,
      serialnumber: this.serial_number,
      title: "",
      deviceID:''
    };
  },
  mounted() {
    this.deviceID = JSON.parse(localStorage.getItem("infoSubDevice")).serial_number
    this.$store.dispatch("InfoSubDevice");
    this.title = 'زون';
    let details = {
      title: this.title,
      add:true
    }
    localStorage.setItem("AppBar", JSON.stringify(details));
    this.$emit('update:layout', LayoutDefault);
    this.$emit('update:update', 'ZoneAlarm');
  },
  watch: {
    click(val) {
      this.onClickChild(val);
    }
  },
  methods: {
    onClickChild(value) {
      if (value == "back") {
        this.$router.push({
          name: "SettingAlarmInfo",
          params: {home_id:this.home_id,serial_number: this.serial_number},
        });
      }
      if (value == "add") {
        this.$router.push({
          name: "ZoneAdd",
          params: {home_id:this.home_id,serial_number: this.serial_number},
        });
      }
    },
  },
};
</script>
<style scoped>
</style>
